import React from 'react';
import { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import { ReactComponent as PhoneIcon } from './../../../assets/icons/phone-simple.svg';
import './telephone.css';

export const Telephone = ({number = '', extension = null, weight = '', fallback = <></>}) => {
    try {
        let isNumericExtension = /^\d+$/.test(extension ?? '');
        
        // Attempt to add a country code if it’s missing
        const formattedNumber = number.startsWith('+') ? number : '+1' + number; // Assuming +1 (USA) by default

        return (isValidPhoneNumber(formattedNumber)) ? (
            <a
                className='telephone-link'
                href={'tel:' + formattedNumber + (isNumericExtension ? ',' + extension : '')}
                title={`Make a phone call to ${formatPhoneNumber(formattedNumber)}${isNumericExtension ? ' ext. ' + extension : ''}`}
            >
                <PhoneIcon className={weight} />
                {formatPhoneNumber(formattedNumber)}{extension && (' ext. ' + extension)}
            </a>
        ) : (
            <>{number}</>
        );
    } catch {
        return fallback;
    }
};